export default {
    props: ['aiData', 'isCreate'],
    data() {
        return {
            aiModelOutputs: [],
            aiModelInputSelectedCodes: [],
            search_input_field: '',
        }
    },
    methods: {
        getDataInputAndOutput() {
            const outputs = this.mapKintoneField(this.aiModelOutputs);
            const inputs = this.allFields.filter((field) => {
                return this.aiModelInputSelectedCodes.indexOf(field.code) >= 0;
            });
            const inputsForPost = this.mapKintoneField(inputs);
            return {
                inputs: inputsForPost,
                outputs: outputs,
            }
        },
        mapKintoneField(data) {
            return data.map((field, index) => {
                return {
                    "index": index,
                    "kintone_field_name": field.label,
                    "kintone_field_code": field.code,
                    "kintone_field_type": field.type,
                    "kintone_field_maxValue": field.maxValue !== undefined ? (field.maxValue != "" ? field.maxValue : 0) : 0,
                    "kintone_field_minValue": field.minValue !== undefined ? (field.minValue != "" ? field.minValue : 0) : 0,
                    "kintone_field_options": field.options !== undefined ? field.options : null,
                    "feature_importance": field.feature_importance !== undefined? (field.feature_importance != "" ? field.feature_importance : 0) : 0,
                };
            });
        },
        addOutput(data) {
            this.aiModelOutputs.push(data);
            // remove out of list selected input
            const indexOfSelectedFieldCode = this.aiModelInputSelectedCodes.indexOf(data.code);
            if (indexOfSelectedFieldCode >= 0) {
                this.aiModelInputSelectedCodes.splice(indexOfSelectedFieldCode, 1);
            }
        },
        addInput(data) {
            // const self = this;
            const indexOfField = this.aiModelOutputs.indexOf(data);
            // console.log(indexOfField);
            if (indexOfField >= 0) {
                this.aiModelOutputs.splice(indexOfField, 1);
            }
        },
        toggleSelectInputField(index) {
            const code = this.inputFields[index].code;
            const indexOfSelectedFieldCode = this.aiModelInputSelectedCodes.indexOf(code);
            if (indexOfSelectedFieldCode >= 0) {
                this.aiModelInputSelectedCodes.splice(indexOfSelectedFieldCode, 1);
            } else {
                this.aiModelInputSelectedCodes.push(code);
            }
        },
        progressColor(importance) {
            if (importance > 0.8) return 'progress-bar bg-success';
            else if(importance > 0.4) return 'progress-bar bg-info';
            else return 'progress-bar bg-danger';
        }
    },
    computed: {
        allFields() {
            // convert props oject to array and subcribe props change
            return Object.values(this.aiData);
        },
        inputFields() {
            const self = this;
            const fieldInputs = this.allFields.filter(function(field) {
                const findFieldOuput = self.aiModelOutputs.find(function(fieldOutPut) {                   
                    return field.code === fieldOutPut.code;
                });
                return findFieldOuput === null || findFieldOuput === undefined;
            });
            // search field input
            const searchedFieldInput = fieldInputs.filter((field) => {
                return field.label.indexOf(this.search_input_field) >= 0 || field.code.indexOf(this.search_input_field) >= 0;
            });
            const fieldInputsWithSelected = searchedFieldInput.map((field) => {
                const indexOfSelectedFieldCode = this.aiModelInputSelectedCodes.indexOf(field.code);
                field.selected = indexOfSelectedFieldCode >= 0;
                return field;
            });
            return fieldInputsWithSelected;
        },
        recordQueryErrorMsg() {
            /*
            if (!this.$v.form.record_query.required) {
                return this.$t('message_error.');
            }
            */

            if (this.errors && this.errors.name) {
                return this.errors.name[0];
            }
            return null;
        }, 
    },
    validations() {
        return {
            record_query: {  },
        }
    }
}